import React from 'react';
import { Link } from 'react-router-dom';

const BASE_CLASSES = 'inline-flex items-center justify-center px-6 py-3 text-sm sm:text-base font-medium rounded-lg transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#7D8471]';
const VARIANTS = {
  outline: 'text-[#7D8471] border border-[#7D8471] hover:bg-[#7D8471] hover:text-white',
  solid: 'bg-[#7D8471] text-white shadow-md hover:bg-[#6B7361]',
};

const BackToHomeLink = ({ className = '', variant = 'outline', ...props }) => {
  const variantClasses = VARIANTS[variant] ?? VARIANTS.outline;
  const combinedClasses = `${BASE_CLASSES} ${variantClasses} ${className}`.trim();

  return (
    <Link to="/" className={combinedClasses} {...props}>
      Retour à l'accueil
    </Link>
  );
};

export default BackToHomeLink;
